import { useParams } from "react-router-dom";
import EnhancementTransactionForm from "./EnhancementTransactionForm";
import { useAuthContext } from "../../../../context/AuthContext";

const TransactionForm = () => {
  const params = useParams();
  const { business } = useAuthContext();
  return (
    <EnhancementTransactionForm
      customerId={params?.id}
      txnsId={params?.txnsId}
      business={business}
    />
  );
};
export default TransactionForm;
